import { useSelector } from "react-redux";
const useAppSelector = (fn) => useSelector(fn);
export default useAppSelector;
